import { useEffect, useState } from 'react'
import type { IslandProps } from '../registry'
import { currentRole } from '../../lib/outreach/api'
import { BusinessTab } from './settings/BusinessTab'
import { ProgramsTab } from './settings/ProgramsTab'
import { SequencesTab } from './settings/SequencesTab'
import { OutreachStyles } from './settings/shared'
import { SuppressionsTab } from './settings/SuppressionsTab'

type Role = 'owner' | 'admin' | 'member'
type TabId = 'programs' | 'sequences' | 'suppressions' | 'business'

const TABS: ReadonlyArray<{ id: TabId; label: string }> = [
  { id: 'programs', label: 'Programs' },
  { id: 'sequences', label: 'Sequences' },
  { id: 'suppressions', label: 'Suppressions' },
  { id: 'business', label: 'Business' },
]

export default function OutreachSettings({ user }: IslandProps) {
  const [tab, setTab] = useState<TabId>('programs')
  const [role, setRole] = useState<Role | null>(null)

  useEffect(() => {
    let live = true
    currentRole()
      .then((r) => live && setRole(r))
      // Unknown role: show the read-only view. The database enforces the real limits.
      .catch(() => live && setRole('member'))
    return () => {
      live = false
    }
  }, [])

  const readOnly = role !== 'owner' && role !== 'admin'
  const userId = user?.id ?? ''

  return (
    <>
      <OutreachStyles />
      <div className="os-root">
        <div className="os-tabs" role="tablist" aria-label="Outreach settings">
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              role="tab"
              id={`os-tab-${t.id}`}
              aria-selected={tab === t.id}
              aria-controls={`os-panel-${t.id}`}
              className="os-tab"
              onClick={() => setTab(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>
        <div role="tabpanel" id={`os-panel-${tab}`} aria-labelledby={`os-tab-${tab}`}>
          {role === null ? (
            <div className="settings-hint">Loading...</div>
          ) : tab === 'programs' ? (
            <ProgramsTab readOnly={readOnly} userId={userId} />
          ) : tab === 'sequences' ? (
            <SequencesTab readOnly={readOnly} />
          ) : tab === 'suppressions' ? (
            <SuppressionsTab />
          ) : (
            <BusinessTab readOnly={readOnly} />
          )}
        </div>
      </div>
    </>
  )
}
